import { MessageTemplateStatus } from "#resources/api/enterprise-generated";

export const modalMyModels = {
	title: "Mis modelos",
	columns: {
		model: "Modelo",
		status: "Estado",
	},
	status: {
		approved: "Aprobado",
		pending: "Procesando",
		received: "Recibido",
		rejected: "Rechazado",
	} as Record<MessageTemplateStatus, string>,
	emptyState: {
		title: "Ninguna plantilla registrada",
		text: "Solicite una nueva plantilla para enviar mensajes de WhatsApp a sus clientes",
	},
	requestNewModel: "Solicitar nuevo modelo",
};
